"use strict";
exports.__esModule = true;
exports.BasketHelperService = void 0;
var session_1 = require("../session");
var operators_1 = require("rxjs/operators");
var basket_service_1 = require("./basket.service");
var store_1 = require("./store");
var http_1 = require("../../core/http");
var basket_api_1 = require("./basket.api");
var rxjs_1 = require("rxjs");
var fetchGetBasket$;
var fetchGetBasket = function (session) {
    if (!fetchGetBasket$) {
        var headers = {
            'X-AVP-Properties': 'Prices|Taxes|RoomInformation|RateInformation|ExtraInformation',
            'X-AVP-PictureTemplates': 'Original|XLarge'
        };
        fetchGetBasket$ = http_1.Http.get(basket_api_1.BasketApi.get(session.sessionId), { headers: headers }).pipe(operators_1.share());
    }
    return fetchGetBasket$;
};
var setLoadingInBasket = function (state) {
    store_1.BasketStore.setLoading(state);
};
var updateBasketAndSession = function (session) {
    return rxjs_1.zip(basket_service_1.BasketService.fetchBasket(session), session_1.SessionService.fetchSession(session.sessionId))
        .pipe(operators_1.map(function (_a) {
        var basket = _a[0];
        return basket;
    }), operators_1.catchError(function (err) {
        return rxjs_1.of(err);
    }));
};
var fetchSetRoomInBasket = function (sessionId, body) {
    return http_1.Http.post(basket_api_1.BasketApi.setRoom(sessionId), body);
};
var fetchSetExtraInBasket = function (sessionId, body) {
    return http_1.Http.post(basket_api_1.BasketApi.setExtra(sessionId), body);
};
var resetCacheFetchGetBasket = function () { return fetchGetBasket$ = null; };
exports.BasketHelperService = {
    updateBasketAndSession: updateBasketAndSession,
    setLoadingInBasket: setLoadingInBasket,
    fetchSetRoomInBasket: fetchSetRoomInBasket,
    fetchSetExtraInBasket: fetchSetExtraInBasket,
    fetchGetBasket: fetchGetBasket,
    resetCacheFetchGetBasket: resetCacheFetchGetBasket
};
//# sourceMappingURL=basket-helper.service.js.map